"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discardReadReceiptOption_1 = require("./actions/discardReadReceiptOption");
var saveReadReceiptOption_1 = require("./actions/saveReadReceiptOption");
var ReadReceiptsFull_1 = require("./components/ReadReceiptsFull");
var isReadReceiptOptionDirty_1 = require("./utils/isReadReceiptOptionDirty");
var React = require("react");
var ReadReceiptsOption = {
    key: 'readReceipts',
    titleStringKey: 'optionTitle_readReceipts',
    searchTermsStringKey: 'optionTitle_readReceipts',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ReadReceiptsFull_1.default, null); },
        isDirty: isReadReceiptOptionDirty_1.default,
        onSave: saveReadReceiptOption_1.default,
        onDiscard: discardReadReceiptOption_1.default,
    },
};
exports.default = ReadReceiptsOption;
//# sourceMappingURL=ReadReceiptsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-read-receipts-option/lib/ReadReceiptsOption.js
// module id = 5058
// module chunks = 2